import { AuthApiError } from '../../../contexts/auth/authApi';

/**
 * The i18n key (under `auth.welcome.errors`) for an error from the
 * passwordless endpoints. The API never returns Auth0's own descriptions, so
 * the message is chosen from the error code alone.
 */
export function authErrorKey(error: unknown): string {
  if (error instanceof AuthApiError) {
    switch (error.code) {
      case 'invalid_email':
      case 'invalid_code':
        return error.code;
      case 'too_many_attempts':
      case 'rate_limited':
        return 'too_many_attempts';
      case 'invalid_request':
        return 'invalid_code';
    }
    if (error.status === 401) return 'invalid_code';
    if (error.status === 429) return 'too_many_attempts';
  }
  return 'upstream_error';
}
